import { I_HowYouRateDevice } from "~/tiw/stores/howYouRateDevice/howYouRateDevice.types";

import axios from "../configRequest";
import { I_AXIOS } from "../configRequest.model";
import { I_API_GET_QUESTIONS_PAYLOAD } from "./types";

export const apiGetQuestions = async (data: I_API_GET_QUESTIONS_PAYLOAD) => {
    const fetchData = await axios.post<I_HowYouRateDevice["questionData"]>(
        I_AXIOS.STAGE_API_HOST +
            `/api/tin/v1/site/quest/question?ans=${data.ans}&c=${data.c}&token=${data.token}&deviceId=${data.deviceId}&questionId=${data.questionId}&lang=${data.lang}`,
    );
    return fetchData.data;
};
